import type { MouseEventHandler } from 'react'

import { Icon } from './Icon'

type CtaProps = {
  children: string
  className?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

export function Cta({ children, className = '', onClick }: CtaProps) {
  return (
    <a
      className={`button ${className}`.trim()}
      href="#conversation"
      onClick={onClick}
    >
      {children}
      <Icon name="arrow" />
    </a>
  )
}

type ReassuranceProps = {
  ink?: boolean
}

export function Reassurance({ ink = false }: ReassuranceProps) {
  return (
    <p className={`reassurance${ink ? ' reassurance--ink' : ''}`}>
      <Icon name="lock" />
      Free, confidential and no obligation.
    </p>
  )
}
